import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, take, filter, map, distinctUntilChanged } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { ApplicationState } from '../../../store/application-store';
import { EmailTemplateModel } from '../models/email-template-model';
import * as emailTemplateActions from '../actions/email-template.actions';
import { selectorDefaultForTemplate, selectConsolidatedTemplates, selectLoading } from '../selectors/email-template.selectors';
import { State } from '../reducers/email-template.reducers';
import { EmailTemplateHttpService } from './email-template-http.service';

@Injectable()
export class EmailTemplateService {

  constructor(
    private readonly store: Store<ApplicationState>,
    private readonly emailTemplateHttp: EmailTemplateHttpService
  ) { }

  factoryReset(template: EmailTemplateModel) {
    this.store
      .pipe(
        select(selectorDefaultForTemplate(template)),
        take(1))
      .subscribe(t => {
        template.subject = t.subject;
        template.template = t.template;
      });
  }

  getAll(): Observable<EmailTemplateModel[]> {
    this.store.dispatch(new emailTemplateActions.Load());
    return this.store
      .pipe(
        select(selectConsolidatedTemplates),
        distinctUntilChanged()
      );
  }

  saveCustomTemplate(template: EmailTemplateModel) {
    return this.emailTemplateHttp.saveCustomTemplate(template).pipe(
      take(1),
      tap((v) => this.store.dispatch(new emailTemplateActions.Load())));
  }

  getLoading(): Observable<boolean> {
    return this.store.pipe(select(selectLoading));
  }



}

